interface DeptFilterProps {
  departments: string[];
  value: string;
  onChange: (value: string) => void;
}

/**
 * «분과» 필터 칩 줄.
 * - [전체] 칩을 맨 앞에 두고 기본 선택.
 * - 목록이 비어 있으면 아무것도 렌더링하지 않는다.
 */
export default function DeptFilter({ departments, value, onChange }: DeptFilterProps) {
  if (departments.length === 0) return null;

  const baseChip = "whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors";

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-foreground-500">
        <i className="ri-node-tree" aria-hidden="true"></i>
        분과
      </span>

      <button
        type="button"
        onClick={() => onChange("")}
        className={`${baseChip} ${
          value === ""
            ? "bg-secondary-500 text-background-50 dark:text-foreground-950"
            : "border border-background-300 bg-background-50 text-foreground-600 hover:bg-background-100"
        }`}
      >
        전체
      </button>

      {departments.map((d) => {
        const active = value === d;
        return (
          <button
            key={d}
            type="button"
            onClick={() => onChange(active ? "" : d)}
            className={`${baseChip} ${
              active
                ? "bg-secondary-500 text-background-50 dark:text-foreground-950"
                : "border border-background-300 bg-background-50 text-foreground-600 hover:bg-background-100"
            }`}
          >
            {d}
          </button>
        );
      })}
    </div>
  );
}